import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { PricingCategory } from "@/app/services/generated/pricingcategoryService";
import { pricingCategoryService } from "@/app/services/generated/pricingcategoryService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasPricingCategoriesCache {
  pricingCategories: PricingCategoriesCache;
}

// Singleton cache store
const pricingCategoriesCacheStore = new EntityCacheStore<PricingCategory>(
  EnumCacheEntityType.pricingCategory,
  async () => pricingCategoryService.getAllPricingCategories()
);

// Ephemeral reader
export default class PricingCategoriesCache extends EntityWithGuidKeyCache<PricingCategory> {
  constructor() {
    super(pricingCategoriesCacheStore, (x) => x.id);
  }
}
